import { Component, Prop, Vue, Ref } from 'vue-property-decorator';
import { StrategyStats } from '@/classes/StrategyStats';

@Component({
  name: 'strat-stats',
  components: {
  },
})
export default class StratStats extends Vue {
  @Prop()
  public strategyStats!: StrategyStats;

  // @Prop()
  // public annualizedSharpe!: number
  // @Prop()
  // public annualizedSortino!: number
  // @Prop()
  // public annualizedReturns!: number
  // @Prop()
  // public meanReturns!: number
  // @Prop()
  // public minBalance!: number
  // @Prop()
  // public maxBalance!: number
  // @Prop()
  // public percentProfitableTrades!: number
  // @Prop()
  // public numHours!: number
  // @Prop()
  // public numTrades!: number
  // @Prop()
  // public percentExecuted!: number
  // @Prop()
  // public percentShort!: number
  // @Prop()
  // public percentLong!: number
  // @Prop()
  // public percentNeutral!: number
  // @Prop()
  // public zscoreFromZero!: number
}
